/**
 * ComingSoon Component - Placeholder for pages under development
 *
 * Displays a "Coming Soon" message with the page name and icon.
 * Used as a placeholder for menu items that haven't been implemented yet.
 */

import { Construction } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { cn } from '@/utils/cn';

import type { LucideIcon } from 'lucide-react';

export interface ComingSoonProps {
  title: string;
  icon?: LucideIcon;
  description?: string;
  className?: string;
}

export function ComingSoon({
  title,
  icon: Icon = Construction,
  description,
  className,
}: ComingSoonProps) {
  const { t } = useTranslation();

  return (
    <div
      className={cn(
        'flex flex-col items-center justify-center min-h-[60vh] p-8',
        className
      )}
    >
      {/* Icon */}
      <div className="w-20 h-20 rounded-2xl bg-[#1357A0]/10 flex items-center justify-center mb-6">
        <Icon className="h-10 w-10 text-[#1357A0]" />
      </div>

      {/* Title */}
      <h1 className="text-2xl font-semibold text-gray-800 mb-2">{title}</h1>

      {/* Coming Soon badge */}
      <div className="px-4 py-1 bg-amber-100 text-amber-700 rounded-full text-sm font-medium mb-4">
        {t('common.comingSoon', 'Coming Soon')}
      </div>

      {/* Description */}
      <p className="text-gray-500 text-center max-w-md">
        {description ?? t('common.comingSoonDescription', 'This feature is currently under development and will be available soon.')}
      </p>
    </div>
  );
}

ComingSoon.displayName = 'ComingSoon';
